/* External */
import {
  memo, useMemo, useEffect, useCallback,
} from 'react';
import PropTypes from 'prop-types';

/* Components */
import ChannelLane from '../ChannelLane';

/* Utils */
import { useItemData } from '../VirtualizedList';
import { Direction } from '../../utils/spatialNavigation';

function EpgRow({ index, firstVisibleElementIndex }) {
  const {
    channels,
    handleChannelArrowPress,
    handleChannelBecameFocused,
    pageId,
    isFetchingSchedules,
    initialSectionIndexEpg,
    shouldStealFocus,
    onFocusStolen,
    withoutFilter,
    biggerChannelLogos,
    epgCommonTagEvent,
  } = useItemData();
  const channel = useMemo(() => channels.get(index), [index, channels]);

  const channelShouldStealFocus = shouldStealFocus && initialSectionIndexEpg === index + 1;

  useEffect(() => {
    if (channelShouldStealFocus) {
      onFocusStolen();
    }
  }, [onFocusStolen, channelShouldStealFocus]);

  const handleOnArrowPress = useCallback((direction, ...props) => {
    if ((index < firstVisibleElementIndex) && direction === Direction.UP) {
      return false;
    }
    return handleChannelArrowPress(direction, ...props);
  }, [handleChannelArrowPress, index, firstVisibleElementIndex]);

  return !!channel && (
    <ChannelLane
      key={channel.channelId}
      className="dtv-html5-c-epg__channel-lane"
      channel={channel}
      position={index}
      shouldStealFocus={channelShouldStealFocus}
      onArrowPress={handleOnArrowPress}
      onBecameFocused={handleChannelBecameFocused}
      pageId={pageId}
      isLoading={isFetchingSchedules}
      withoutFilter={withoutFilter}
      biggerLogo={biggerChannelLogos}
      epgCommonTagEvent={epgCommonTagEvent}
    />
  );
}

EpgRow.propTypes = {
  index: PropTypes.number.isRequired,
  firstVisibleElementIndex: PropTypes.number.isRequired,
};

export default memo(EpgRow);
